import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import bp from 'Styles/breakpoints';
import { black } from 'Styles/colors';
import { fontBody } from 'Styles/fonts';

export const MINI_SWATCH_HEIGHT = 21;
export const REGULAR_SWATCH_HEIGHT = 23;

export const ColorSelection = styled.div`
  background-color: transparent;
  box-sizing: content-box;
  min-height: ${MINI_SWATCH_HEIGHT}px;
  padding-bottom: 6px;

  ${({ $styleQueryMode }) => css`
    ${bp('medium', { mode: $styleQueryMode })} {
      min-height: ${REGULAR_SWATCH_HEIGHT * 1.33}px;
    }
  `}

  /* 
    This style must remain a media query.
    This adds bottom padding when a bottom buttom, 
    such as QuickAdd, is on the Product Card.
  */
  ${bp('large')} {
    padding-bottom: 10px;
  }
`;

export const Swatch = styled.div`
  display: grid;
  position: relative;
  z-index: 100;
`;

export const Link = styled.a`
  ${fontBody(13)}
  line-height: 1;
  grid-column: span 3;
  text-decoration: none;
  color: ${black};
  z-index: 1;

  ${({ isOpen, $styleQueryMode }) => css`
    ${bp('medium', { mode: $styleQueryMode })} {
      ${fontBody(16)}
      line-height: 1;
    }

    ${bp('large', { mode: $styleQueryMode })} {
      ${isOpen && 'opacity: 0; display: none;'}
    }
  `}
`;

export const Dropdown = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 6px;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${MINI_SWATCH_HEIGHT}px, 1fr)
  );
  width: 100%;
  background-color: transparent;

  ${({ $styleQueryMode }) => css`
    ${bp('medium', { mode: $styleQueryMode })} {
      grid-gap: 8px;
      grid-template-columns: repeat(auto-fill, ${REGULAR_SWATCH_HEIGHT}px);
    }
  `}

  ${ifProp(
    '$showMoreLink',
    () => css`
      ${Swatch}:nth-child(n + 4) {
        opacity: 0;
        display: none;
      }
    `
  )}

  ${({ isOpen, $styleQueryMode }) => css`
    ${bp('large', { mode: $styleQueryMode })} {
      ${isOpen &&
      `${Swatch}:nth-child(n + 4) {
            opacity: 1;
            display: block;
          }
        `}
    }
  `}
`;
